/**
 * The source of truth for all the path names in the `admin` application.
 *
 */
export const PATHS_NAMES = {
  DASHBOARD: 'dashboard',
  GRN_DASHBOARD: 'grndashboard',
  MTO_HOMEPAGE_PREVIEW: 'mto-homepage-preview',

  CC_GROUP: 'ccgroup',
  CUSTOMERS: 'customers',
  COYU_CREDITS: 'credit-history',
  STORE_CREDITS: 'storecredits',
  VIRTUAL_TRY_ONS: 'virtual-try-ons',
  ORDERS: 'orders',
  TEST_ORDERS: 'test-orders',
  PACKAGES: 'packages',
  ORDER_LINE_ITEMS: 'lineitems',
  RETURNS: 'returns',
  RETURN_APPROVALS: 'return-approvals',
  RETURN_COURIER_EXCEPTIONS: 'return-courier-exceptions',
  REFUNDS: 'refunds',
  ORDER_CONTROL_CENTER: 'ordercontrolcenter',
  MTO_TRACKER: 'mtotracker',
  B2B2C_TRACKER: 'b2b2ctracker',
  COMMENTS: 'comments',
  // MY_REFERRAL: 'my-referral',

  PRODUCTS: 'products',
  CATEGORIES: 'categories',
  SKU_ALBUMS: 'skualbums',
  AI_ALBUMS: 'aialbums',
  INVENTORY: 'inventory',
  CYCLE_COUNT: 'cycle-count',
  SKU_DELETE: 'sku-delete',

  SETTINGS: 'settings',
  UTILITY: 'utility',
  SKILLS: 'skills',
  DATA_ANALYST_SKILL: 'data-analyst',
  CRM: 'crm',
  ASSETS: 'assets',
  DEEPLINKS: 'deeplinks',
  NOTIFICATIONS: 'notifications',
  CRM_MANAGEMENT: 'crm-management',
  FACILITIES: 'facilities',
  SALES_CHANNELS: 'saleschannels',
  USER_GROUP: 'usergroup',
  ERP_USERS: 'erpusers',
  VENDOR_USERS: 'vendorusers',
  STORE_USERS: 'storeusers',

  SUPPLY: 'supply',

  VENDOR_MANAGEMENT: 'vendormanagement',
  SKUS: 'skus',
  VENDORS: 'vendors',
  COUPON_MANAGEMENT: 'couponmanagement',
  COUPONS: 'coupons',
  PROMOTIONS: 'promotions',
  VENDOR_FACILITIES: 'vendorfacilities',
  VENDOR_INVENTORY: 'vendorinventory',
  SKU_ENQUIRY_HISTORY: 'sku-enquiry-history',

  BUYING: 'buying',
  INBOUND: 'inbound',
  DELIVERY_CHALLANS: 'deliverychallans',
  GRN: 'grn',
  PO: 'purchaseorders',
  MTO_PO: 'mtopurchaseorders',

  SKU_UPLOAD: 'skuupload',
  PINCODE: 'pincode',

  LOOKBOOK: 'lookbook',

  SHOPIFY: 'shopify',
  METAFIELDS: 'metafields',
  PAGES: 'pages',
  COLLECTIONS: 'collections',
  QUESTIONNAIRE: 'questionnaire',
  BETTER_INVENTORY: 'better-inventory',
  STYLE_METADATA_CORRECTIONS: 'style-metadata-corrections',

  ATTRIBUTES: 'attributes',
  SORT_STRATEGIES: 'sort-strategies',
  STOCK_TRANSFER: 'stocktransfer',
  INCOMING_STOCK_TRANSFERS: 'incoming-stock-transfers',
  OUTGOING_STOCK_TRANSFERS: 'outgoing-stock-transfers',
  GATEPASS_ORDERS: 'gatepass-orders',
  BULK_PICK: 'bulk-pick',
  INCOMING_MANIFESTS: 'incoming-manifests',
  OUTGOING_MANIFESTS: 'outgoing-manifests',
  MANIFESTS: 'manifests',

  ON_HOLD_ORDERS: 'on-hold-orders',

  ORDER_MANAGEMENT_SYSTEM: 'oms',

  STORE_IMAGES: 'store-images',
  AUDIT_HISTORY: 'audit-history',
  TARGETS: 'targets',
  ANALYTICS_CONTRACT: 'analytics-contract',
  MY_RIDES: 'my-rides',
  RIDER_MANAGEMENT: 'rider-management',
  RIDER_HEALTH: 'rider-health',
  CASH_HANDOVER: 'cash-handover',
  RIDER_ATTENDANCE_QR: 'rider-attendance-qr',
  LOGISTICS: 'logistics',
  DASH_ORDERS: 'dash-orders',
  REFUNDS_ON_HOLD: 'refunds-onhold',
  CUSTOMER_ACTION_TASKS: 'customer-action-tasks',
  B2B_CUSTOMERS: 'b2bcustomers',

  REPORTS: 'reports',
  MERCH_REPORTS: 'merch-reports',
  OPS_REPORTS: 'ops-reports',
  WEEKLY_MERCH_OVERVIEW: 'weekly-merch-overview',
  STORE_BRAND_OVERVIEW: 'store-brand-overview',
  MONTHLY_MERCH_KPIS_OVERVIEW: 'monthly-merch-kpis-overview',
  BESTSELLERS_TRENDS_OVERVIEW: 'bestsellers-trends-overview',
  STOCK_TRANSFER_OVERVIEW: 'stock-transfer-overview',
  MTO_HEALTH_OVERVIEW: 'mto-health-overview',
  JIT_B2B2C_OVERVIEW: 'jit-b2b2c-overview',
  CATALOGING_HEALTH_OVERVIEW: 'cataloging-health-overview',
  STOCK_AGEING_OVERVIEW: 'stock-ageing-overview',
  ONLINE_PERFORMANCE_OVERVIEW: 'online-performance-overview',
  STOCK_RECONCILIATION_OVERVIEW: 'stock-reconciliation-overview',
  MERCH_SCORECARD: 'merch-scorecard',
  STYLIST_LEADERBOARD: 'stylist-leaderboard',
  OPS_MOVEMENTS_OVERVIEW: 'ops-movements-overview',
  OPS_STOCK_OVERVIEW: 'ops-stock-overview',
} as const;

export type PathsNamesType = (typeof PATHS_NAMES)[keyof typeof PATHS_NAMES];
